export const DOMAIN_EVENT_TYPES = [
    'order.created',
    'order.status_changed',
    'order.tracking_changed',
    'order.payment_changed',
    'store.status_changed',
];
export const DEFAULT_NOTIFICATION_PREFS = {
    enabled: true,
    newOrders: true,
    statusChanges: true,
    trackingChanges: true,
    payments: true,
    storeStatus: true,
    quietHours: null,
    storeIds: [],
    silentMessages: false,
};
//# sourceMappingURL=events.js.map